import { GetEpisodeConsentsResponse } from '@lyrahealth-inc/shared-app-logic/src/models/consent/Consent'

import { baseApi } from '../../../data/baseApi'

type GetEpisodeConsentsArgs = {
  episodeId: string
}

const consentApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getEpisodeConsents: builder.query<GetEpisodeConsentsResponse, GetEpisodeConsentsArgs>({
      query: ({ episodeId }) => ({
        method: 'get',
        url: `/lt/v1/episode/${episodeId}/consents`,
      }),
    }),
  }),
})

export const { useGetEpisodeConsentsQuery } = consentApi
export default consentApi
